<mat-slide-toggle [formControl]="control">
  <strong>{{ label }}</strong>
</mat-slide-toggle>
